import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetOrganizationLogo } from "redux/organizationSlice";
import { fetchAsyncGetOrganization } from "redux/organizationSlice";

const useOrganizationData = () => {
  const [organizationData, setOrganizationData] = useState({});
  const organizationList = useSelector((state) => state.organizationData);
  const [loading, setLoading] = useState(true); 

  const logoData = useSelector((state) => state.logoData);
  const dispatch = useDispatch();
  const logoUrl = logoData?.downloadUrl || "";

  useEffect(() => {
    (async()=>{
      setLoading(true);
      await dispatch(fetchAsyncGetOrganization());
      await dispatch(fetchAsyncGetOrganizationLogo());
      setLoading(false); 
    })()

  }, [dispatch]);

  useEffect(() => {
    if (organizationList && organizationList.length) {
      setOrganizationData(organizationList[0]);
    }
  }, [organizationList]);

  return { 
    organizationList,
    organizationData, 
    logoUrl,
    loading,
    setLoading
   };
};

export default useOrganizationData;
